import React from 'react';
import '../components/CRMProfileScreen.css';

const SaveFirstModal = ({ isOpen, onSave, onCancel, isSaving }) => {
    if (!isOpen) return null;

    return (
        <div className="crm-modal-overlay">
            <div className="crm-modal-content">
                <div className="crm-modal-header">
                    <h3>Save Profile First</h3>
                </div>
                
                <div className="crm-modal-body">
                    <p>
                        You have unsaved changes that will be used in the AI risk analysis. 
                        Please save your profile first to ensure the analysis uses the most current data.
                    </p>
                    
                    <div className="crm-unsaved-changes-note">
                        <strong>What will be saved:</strong>
                        <ul>
                            <li>Risk categories</li>
                            <li>Manual risk analysis notes</li>
                            <li>Overall risk rating</li>
                            <li>All other profile changes</li>
                        </ul>
                    </div>
                </div>
                
                <div className="crm-modal-actions">
                    <button
                        className="crm-btn-primary"
                        onClick={onSave}
                        disabled={isSaving}
                    >
                        {isSaving ? 'Saving...' : 'Save Profile & Run Analysis'}
                    </button>
                    <button
                        className="crm-btn-secondary"
                        onClick={onCancel}
                        disabled={isSaving}
                    >
                        Cancel
                    </button>
                </div>
            </div>
        </div>
    );
};

export default SaveFirstModal; 